import script from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportPPTX.vue?vue&type=script&lang=ts&setup=true"

import "./ExportPPTX.vue?vue&type=style&index=0&id=17b32ec1&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b32ec1"]])

export default __exports__